import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="checkbox-collection"
export default class extends Controller {
  static targets = ["input"];

  reset() {
    this.inputTargets.forEach(function(inputTarget) {
      inputTarget.checked = false;
    });
  }
}
